import React, { PropsWithChildren } from 'react';
import { EmailValidity } from '@/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { faSpinner, faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import { Tooltip } from '@/components/Tooltip';
import theme from './RegisterForm.module.scss';

interface RegisterFormEmailWrapperProps extends PropsWithChildren {
    emailValidity: EmailValidity;
}

const RegisterFormEmailWrapper: React.FC<RegisterFormEmailWrapperProps> = ({ emailValidity, children }) => {
    return (
        <div className={theme.emailContainer}>
            {children}
            <div className={theme.emailValidityIcon}>
                {(emailValidity === EmailValidity.BadEmail || emailValidity === EmailValidity.AlreadyExists) && (
                    <FontAwesomeIcon className={theme.error} icon={faTimes} />
                )}
                {emailValidity === EmailValidity.Checking && <FontAwesomeIcon spin icon={faSpinner} />}
                {emailValidity === EmailValidity.Valid && (
                    <>
                        <Tooltip content={<Trans>Email is valid.</Trans>}>
                            <span>
                                <FontAwesomeIcon className={theme.success} icon={faCheck} />
                            </span>
                        </Tooltip>
                    </>
                )}
            </div>
            {emailValidity === EmailValidity.BadEmail && (
                <p>
                    <Trans>Invalid email.</Trans>
                </p>
            )}
            {emailValidity === EmailValidity.AlreadyExists && (
                <p>
                    <Trans>A user with this email address already exists.</Trans>
                </p>
            )}
        </div>
    );
};

export default RegisterFormEmailWrapper;
